import React, { useEffect, useState } from "react";
import PunPerformance from "./Table/PunPerformance";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../Utilitie";
const PunctualityPerformanceMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const [date, setDate] = useState(getCurrentDate());

  const [startDate, setStartDate] = useState(getCurrentDate());
  const [fetchState, setFetchState] = useState(false);
  const [pPData, setPPData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    let url = `${urlPrefix}get_icms_report02?start=${startDate}&end=${date}`;
    // &group_type=M&train_type=GBR
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      if (data.status === "ok") {
        setPPData(data);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      setError(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [fetchState]);
  return (
    <div>
      <div className="row ms-1 me-1 print-section">
        <div className="p-1 d-flex justify-content-between align-items-center bg-dark text-white">
          <h6 className="">PDD Data Till ({date})</h6>
          <div className="d-flex">
            <input
              className=""
              type="date"
              max={date}
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />{" "}
            <input
              className=""
              type="date"
              min={startDate}
              max={getCurrentDate()}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
            <button
              className="btn btn-sm btn-outline-light"
              onClick={() => setFetchState(!fetchState)}
            >
              fetch
            </button>
          </div>
        </div>
      </div>
      {pPData && (
        <PunPerformance
          data={pPData.daterange.report02}
          groupSum={{
            group_M: pPData.daterange.report02_group_type_M,
            group_P: pPData.daterange.report02_group_type_P,
            group_MPS: pPData.daterange.report02_group_type_P_S_M,
            group_S: pPData.daterange.report02_group_type_S,
          }}
        />
      )}
    </div>
  );
};
export default PunctualityPerformanceMaster;
